import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { IDialogModel, ISessionData } from "@/index";
import { RootState } from "@/redux";
import {
  AppointmentByTimeRangeInfo,
  IAppointmentByTimeRangeRequest,
  IFetchResourceRequest,
  ResourceInfo,
} from "@/services/resource-service/entity/ResourceEntity";
import { MeetingDetails } from "./entity/MeeingEntity";
import { FloorPlanInfo, IFetchFloorPlanRequest } from "./entity/FloorplanEntity";

export const TokenIResourceService = "IResourceService";

export interface IResourceService {
  fetchMeetingByDate(
    request: IFetchResourceRequest,
    start: string,
    end: string,
    resourceId: string
  ): Promise<SearchResponse<MeetingDetails>>;
  fetchMeetingDaysByMonth(
    request: IFetchResourceRequest,
    date: string,
    resourceId: string
  ): Promise<SearchResponse<string>>;
  fetchResources(
    request: IFetchResourceRequest
  ): Promise<SearchResponse<ResourceInfo>>;
  toggleSelectResource(resource: ResourceInfo): void;
  toggleRemoveResource(resource: ResourceInfo): void;
  toggleRemoveResources(resources: ResourceInfo[]): void;
  fetchResourcesByEmails(
    request: IFetchResourceRequest
  ): Promise<SearchResponse<ResourceInfo>>;
  onShowFloorPlanDialog(
    currentIndex?: number,
    callback?: (dialog: IDialogModel) => void,
    data?: RootState
  ): void;
  fetchResourceFloorPlan(
    request: IFetchFloorPlanRequest
  ): Promise<HttpResponse<FloorPlanInfo>>;
  fetchSessionDataForFloorPlanDialog(sessionId: string): Promise<HttpResponse<ISessionData>>;
  fetchAppointmentsByTimeRange(tenantId: string, req: IAppointmentByTimeRangeRequest): Promise<SearchResponse<AppointmentByTimeRangeInfo>>;
}
